module.exports = __webpack_public_path__ + "static/kartchen3-b1ae789de1efe9d921d125d3c2b546f5.png";